<template>
    <ion-page>
        <ion-header>
            <ion-toolbar
                style="--background: #03a9f4; color: white; --min-height: 36px"
                class="custom-toolbar"
            >
                <div class="row align-center">
                    <slot name="before">
                        <div class="shrink">
                            <DxButton
                                type="default"
                                icon="mdi mdi-chevron-left"
                                class="ml-1"
                                @click="$router.go(-1)"
                            />
                        </div>
                    </slot>
                    <slot name="center">
                        <div class="grow text-xs-center">DANH SÁCH LÁI XE</div>
                    </slot>
                    <slot name="after">
                        <div class="shrink">
                            <DxButton
                                type="default"
                                icon="mdi mdi-plus-circle"
                                class="mr-1"
                                @click="$router.push('/Thong-Tin-Lai-Xe')"
                            /></div
                    ></slot>
                </div>
            </ion-toolbar>
        </ion-header>
        <ion-content :scroll-events="false">
            <div class="row mb-1 px-2 mt-2">
                <div class="xs12">
                    <DxTextBox
                        v-model="TextTimKiem"
                        mode="text"
                        placeholder="Nhập để tìm kiếm (Tên, GPLX, SDT,...)"
                        styling-mode="outlined"
                        validationMessageMode="always"
                        :height="36"
                        valueChangeEvent="keyup"
                    />
                </div>
            </div>
            <DataListVue :DanhSachLaiXe="DanhSachLaiXe" @getData="LayDanhSachLaiXe" />
        </ion-content>
    </ion-page>
</template>
<script>
import { DxTextBox } from "devextreme-vue/text-box";
import {
    IonHeader,
    IonToolbar,
    IonContent,
    IonPage,
    onIonViewWillLeave,
    onIonViewWillEnter,
} from "@ionic/vue";
import { DxButton } from "devextreme-vue";
import DataListVue from "./components/DataList.vue";
export default {
    components: {
        DxTextBox,
        IonHeader,
        IonToolbar,
        IonContent,
        IonPage,
        DxButton,
        DataListVue,
    },
    data() {
        return {
            DanhSachLaiXe: [],
            TextTimKiem: "",
        };
    },
    computed: {},
    watch: {
        TextTimKiem(value) {
            setTimeout(() => {
                if (value == this.TextTimKiem) {
                    this.LayDanhSachLaiXe();
                }
            }, 1100);
        },
    },
    methods: {
        async LayDanhSachLaiXe() {
            try {
                this.DanhSachLaiXe = (
                    await this.$store.dispatch("ThongTinLaiXe/Reload_DanhSachLaiXe", {
                        TextTimKiem: this.TextTimKiem,
                    })
                ).Store;
            } catch (ex) {
                console.log("🚀 ex", ex);
            }
        },
    },
    created() {
        onIonViewWillEnter(() => {
            this.LayDanhSachLaiXe();
        });
    },
    async mounted() {
        onIonViewWillLeave(() => {});
    },
};
</script>

<style scoped>
:deep(.dx-texteditor.dx-editor-outlined .dx-placeholder::before) {
    padding: 4px 16px 0px;
}
</style>
